export const contractTranslation = {
  billingData: {
    pageTitle: 'contract.billingData.pageTitle',
    form: {
      data: {
        title: 'contract.billingData.form.data.title',
        description: 'contract.billingData.form.data.description',
        link: 'contract.billingData.form.data.link',
        subject: 'contract.billingData.form.data.subject',
        name: {
          label: 'contract.billingData.form.data.name.label',
          placeholder: 'contract.billingData.form.data.name.placeholder',
          tooltip: 'contract.billingData.form.data.name.tooltip',
        },
        afiliateCode: {
          label: 'contract.billingData.form.data.afiliateCode.label',
          placeholder: 'contract.billingData.form.data.afiliateCode.placeholder',
        },
        cif: {
          label: 'contract.billingData.form.data.cif.label',
          placeholder: 'contract.billingData.form.data.cif.placeholder',
        },
        phoneNumber: {
          label: 'contract.billingData.form.data.phoneNumber.label',
          placeholder: 'contract.billingData.form.data.phoneNumber.placeholder',
        },
      },
      editLabel: 'contract.billingData.form.edit_label',
      cancelLabel: 'contract.billingData.form.cancel_label',
      saveLabel: 'contract.billingData.form.save_label',
      address: {
        title: 'contract.billingData.form.address.title',
        warning: 'contract.billingData.form.address.warning',
        street: {
          label: 'contract.billingData.form.address.street.label',
          placeholder: 'contract.billingData.form.address.street.placeholder',
          tooltip: 'contract.billingData.form.address.street.tooltip',
        },
        number: {
          label: 'contract.billingData.form.address.number.label',
          placeholder: 'contract.billingData.form.address.number.placeholder',
        },
        additionalInfo: {
          label: 'contract.billingData.form.address.additionalInfo.label',
          placeholder: 'contract.billingData.form.address.additionalInfo.placeholder',
        },
        floorBlockStair: {
          label: 'contract.billingData.form.address.floorBlockStair.label',
          placeholder: 'contract.billingData.form.address.floorBlockStair.placeholder',
        },
        postalCode: {
          label: 'contract.billingData.form.address.postalCode.label',
          placeholder: 'contract.billingData.form.address.postalCode.placeholder',
        },
        city: {
          label: 'contract.billingData.form.address.city.label',
          placeholder: 'contract.billingData.form.address.city.placeholder',
        },
        province: {
          label: 'contract.billingData.form.address.province.label',
          placeholder: 'contract.billingData.form.address.province.placeholder',
        },
        noPlacesError: 'contract.billingData.form.address.noPlacesError',
      },
    },
  },
  productsData: {
    pageTitle: 'contract.productsData.pageTitle',
    premiumLegend: 'contract.productsData.premium.legend',
    summary: {
      title: 'contract.productsData.summary.title',
      paymentMethod: 'contract.productsData.summary.paymentMethod',
      chargeDate: 'contract.productsData.summary.chargeDate',
      billingType: 'contract.productsData.summary.billingType',
      methods: {
        transfer: 'contract.productsData.summary.methods.transfer',
        moneyCheck: 'contract.productsData.summary.methods.moneyCheck',
      },
      types: {
        electronic: 'contract.productsData.summary.types.electronic',
        paper: 'contract.productsData.summary.types.paper',
      },
    },
    products: {
      title: 'contract.productsData.products.title',
      table: {
        state: 'contract.productsData.products.table.state',
        valid: 'contract.productsData.products.table.valid',
      },
      availableSubProductsTitle: 'contract.productsData.products.availableSubProductsTitle',
      pill: {
        title: 'contract.productsData.products.pill.nuevo',
      },
      tooltipText: {
        santanderText:'contract.productsData.products.tooltipText.santander',
        iberiaText:   'contract.productsData.products.tooltipText.iberia',
        mapfreText:   'contract.productsData.products.tooltipText.mapfre',
        participationText: 'contract.productsData.products.tooltipText.participation',
      },
      buttons: {
        downloadContract: 'contract.productsData.products.buttons.downloadContract',
        downloadContractHelpText:
          'contract.productsData.products.buttons.downloadContractHelpText',
        hire:'contract.productsData.products.buttons.hire'
      },
      mailto: 'contract.productsData.products.mailto',
    },
  },
  changeBankAccount: {
    pageTitle: 'contract.changeBankAccount.pageTitle',
    introduction: 'contract.changeBankAccount.introduction',
    introductionGuarderia: 'contract.changeBankAccount.introductionGuarderia',
    stepper: {
      step1: 'contract.changeBankAccount.stepper.step1',
      step2: 'contract.changeBankAccount.stepper.step2',
      step3: 'contract.changeBankAccount.stepper.step3',
      step4: 'contract.changeBankAccount.stepper.step4',
    },
    accessCard: {
      title: 'contract.changeBankAccount.accessCard.title',
      iban: {
        label: 'contract.changeBankAccount.accessCard.iban.label',
        tooltip: 'contract.changeBankAccount.accessCard.iban.tooltip',
      },
      button: {
        label: 'contract.changeBankAccount.accessCard.button.label',
        billingData: "contract.changeBankAccount.billingData",
      },
    },
    form: {
      title: 'contract.changeBankAccount.form.title',
      title2: 'contract.changeBankAccount.form.title2',
      data: {
        currentIban: {
          label: 'contract.changeBankAccount.form.data.currentIban.label',
          placeholder: 'contract.changeBankAccount.form.currentIban.iban.placeholder',
        },
        newIban: {
          label: 'contract.changeBankAccount.form.data.newIban.label',
          placeholder: 'contract.changeBankAccount.form.newIban.iban.placeholder',
        },
        signerName: {
          label: 'contract.changeBankAccount.form.data.signerName.label',
          placeholder: 'contract.changeBankAccount.form.data.signerName.placeholder',
          tooltip: 'contract.changeBankAccount.form.data.signerName.tooltip',
        },
        signerSurname1: {
          label: 'contract.changeBankAccount.form.data.signerSurname1.label',
          placeholder: 'contract.changeBankAccount.form.data.signerSurname1.placeholder',
        },
        signerSurname2: {
          label: 'contract.changeBankAccount.form.data.signerSurname2.label',
          placeholder: 'contract.changeBankAccount.form.data.signerSurname2.placeholder',
        },
        signerDocumentType: {
          label: 'contract.changeBankAccount.form.data.signerDocumentType.label',
          placeholder:
            'contract.changeBankAccount.form.data.signerDocumentType.placeholder',
          legend: 'contract.changeBankAccount.form.data.signerDocumentType.legend',
        },
        signerDocument: {
          label: 'contract.changeBankAccount.form.data.signerDocument.label',
          placeholder: 'contract.changeBankAccount.form.data.signerDocument.placeholder',
        },
        signerPhoneId: {
          label: 'contract.changeBankAccount.form.data.signerPhoneId.label',
          placeholder: 'contract.changeBankAccount.form.data.signerPhoneId.placeholder',
          legend: 'contract.changeBankAccount.form.data.signerPhoneId.legend',
          legendGuarderia: 'contract.changeBankAccount.form.data.signerPhoneId.legendGuarderia',
          tooltip: 'contract.changeBankAccount.form.data.signerPhoneId.tooltip',
        },
        accepted: {
          label: 'contract.changeBankAccount.form.data.accepted.label',
        },
      },
    },
    step1: {
      noPhones: 'contract.changeBankAccount.step1.noPhones',
      noPhonesGuarderia: 'contract.changeBankAccount.step1.noPhonesGuarderia',
      noPhonesGuarderiaEmail: 'contract.changeBankAccount.step1.noPhonesGuarderiaEmail',
      buttons: {
        previous: {
          label: 'contract.changeBankAccount.step1.buttons.previous.label',
        },
        next: {
          label: 'contract.changeBankAccount.step1.buttons.next.label',
        },
      },
    },
    step2: {
      title: 'contract.changeBankAccount.step2.title',
      title2: 'contract.changeBankAccount.step2.title2',
      sepaIntroduction: 'contract.changeBankAccount.step2.sepaIntroduction',
      downloadSepa: {
        label: 'contract.changeBankAccount.step2.downloadSepa.label',
      },
      buttons: {
        previous: {
          label: 'contract.changeBankAccount.step2.buttons.previous.label',
        },
        next: {
          label: 'contract.changeBankAccount.step2.buttons.next.label',
          tooltip: 'contract.changeBankAccount.step2.buttons.next.tooltip',
        },
      },
    },
    step4: {
      status: {
        checking: {
          description: 'contract.changeBankAccount.step4.status.checking.description',
        },
        ok: {
          title: 'contract.changeBankAccount.step4.status.ok.title',
          description: 'contract.changeBankAccount.step4.status.ok.description',
        },
        ko: {
          title: 'contract.changeBankAccount.step4.status.ko.title',
          description: 'contract.changeBankAccount.step4.status.ko.description',
          description2: 'contract.changeBankAccount.step4.status.ko.description2',
        },
        debt: {
          description: 'contract.changeBankAccount.step4.status.debt.description',
        },
      },
      buttons: {
        finish: {
          label: 'contract.changeBankAccount.step4.buttons.finish.label',
        },
      },
    },
    modal: {
      title: 'contract.changeBankAccount.modal.title',
      description: 'contract.changeBankAccount.modal.description',
    },
  },
  accountingStatus: {
    warned: 'contract.accountingStatus.warned',
    blocked: 'contract.accountingStatus.blocked',
    link: 'contract.accountingStatus.link',
    modal: {
      title: 'contract.accountingStatus.modal.title',
      text1: 'contract.accountingStatus.modal.text1',
      text2: 'contract.accountingStatus.modal.text2',
      paymentTitle: 'contract.accountingStatus.modal.paymentTitle',
      paymentText: 'contract.accountingStatus.modal.paymentText',
      paymentOption1: 'contract.accountingStatus.modal.paymentOption1',
      paymentOption2: 'contract.accountingStatus.modal.paymentOption2',
    },
    processUnpaidInvoicesExit: 'contract.accountingStatus.processUnpaidInvoicesExit',
  },
}

export const productContractingTranslation = {
  banner: {
    active: {
      title: 'productContracting.banner.active.title',
      subtitle: 'productContracting.banner.active.subtitle',
      cta: {
        label: 'productContracting.banner.active.cta.label',
      },
    },
    inactive: {
      title: 'productContracting.banner.inactive.title',
      subtitle: 'productContracting.banner.inactive.subtitle',
    },
  },
  contractProductPage: {
    pageTitle: 'productContracting.contractProductPage.pageTitle',
    introduction: 'productContracting.contractProductPage.introduction',
    stepper: {
      step1: 'productContracting.contractProductPage.stepper.step1',
      step2: 'productContracting.contractProductPage.stepper.step2',
      step3: 'productContracting.contractProductPage.stepper.step3',
      step4: 'productContracting.contractProductPage.stepper.step4',
      step5: 'productContracting.contractProductPage.stepper.step5',
    },
    step1: {
      buttons: {
        previous: {
          label: 'productContracting.contractProductPage.step1.buttons.previous.label',
        },
        next: {
          label: 'productContracting.contractProductPage.step1.buttons.next.label',
          disabled: 'productContracting.contractProductPage.step1.buttons.next.disabled',
        },
      },
    },
    step2: {
      form: {
        title: 'productContracting.contractProductPage.step2.form.title',
        description: {
          editable: 'productContracting.contractProductPage.step2.form.description.editable',
          noEditable:
            'productContracting.contractProductPage.step2.form.description.noEditable',
          noEditableMailSubject:
            'productContracting.contractProductPage.step2.form.description.noEditableMailSubject',
        },
        data: {
          name: {
            label: 'productContracting.contractProductPage.step2.form.data.name.label',
            placeholder:
              'productContracting.contractProductPage.step2.form.data.name.placeholder',
          },
          surname1: {
            label:
              'productContracting.contractProductPage.step2.form.data.surname1.label',
            placeholder:
              'productContracting.contractProductPage.step2.form.data.surname1.placeholder',
          },
          surname2: {
            label:
              'productContracting.contractProductPage.step2.form.data.surname2.label',
            placeholder:
              'productContracting.contractProductPage.step2.form.data.surname2.placeholder',
          },
          documentType: {
            label:
              'productContracting.contractProductPage.step2.form.data.documentType.label',
            placeholder:
              'productContracting.contractProductPage.step2.form.data.documentType.placeholder',
            legend:
              'productContracting.contractProductPage.step2.form.data.documentType.legend',
          },
          documentNumber: {
            label:
              'productContracting.contractProductPage.step2.form.data.document.label',
            placeholder:
              'productContracting.contractProductPage.step2.form.data.document.placeholder',
          },
          phone: {
            label: 'productContracting.contractProductPage.step2.form.data.phone.label',
            placeholder:
              'productContracting.contractProductPage.step2.form.data.phone.placeholder',
            legend: 'productContracting.contractProductPage.step2.form.data.phone.legend',
            tooltip:
              'productContracting.contractProductPage.step2.form.data.phone.tooltip',
          },
          email: {
            label: 'productContracting.contractProductPage.step2.form.data.email.label',
            placeholder:
              'productContracting.contractProductPage.step2.form.data.email.placeholder',
            tooltip:
              'productContracting.contractProductPage.step2.form.data.email.tooltip',
          },
        },
      },
      buttons: {
        previous: {
          label: 'productContracting.contractProductPage.step2.buttons.previous.label',
        },
        next: {
          label: 'productContracting.contractProductPage.step2.buttons.next.label',
        },
      },
    },
    step3: {
      resume: {
        title: 'productContracting.contractProductPage.step3.resume.title',
      },
      signDocuments: {
        title: 'productContracting.contractProductPage.step3.signDocuments.title',
        description:
          'productContracting.contractProductPage.step3.signDocuments.description',
      },
      buttons: {
        previous: {
          label: 'productContracting.contractProductPage.step3.buttons.previous.label',
        },
        next: {
          label: 'productContracting.contractProductPage.step3.buttons.next.label',
          disabled: 'productContracting.contractProductPage.step3.buttons.next.disabled',
        },
      },
    },
    confirmationScreen: {
      pending: {
        description:
          'productContracting.contractProductPage.confirmationScreen.pending.description',
      },
      success: {
        title: 'productContracting.contractProductPage.confirmationScreen.success.title',
        description:
          'productContracting.contractProductPage.confirmationScreen.success.description',
        button: {
          label:
            'productContracting.contractProductPage.confirmationScreen.success.button.label',
        },
      },
      error: {
        title: 'productContracting.contractProductPage.confirmationScreen.error.title',
        description:
          'productContracting.contractProductPage.confirmationScreen.error.description',
        button: {
          label:
            'productContracting.contractProductPage.confirmationScreen.error.button.label',
        },
      },
    },
  },
}
